import { render, staticRenderFns } from "./videodecodesupportrecord.vue?vue&type=template&id=5a5fdc3a&scoped=true"
import script from "./videodecodesupportrecord.vue?vue&type=script&lang=js"
export * from "./videodecodesupportrecord.vue?vue&type=script&lang=js"
import style0 from "./videodecodesupportrecord.vue?vue&type=style&index=0&id=5a5fdc3a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5fdc3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a5fdc3a')) {
      api.createRecord('5a5fdc3a', component.options)
    } else {
      api.reload('5a5fdc3a', component.options)
    }
    module.hot.accept("./videodecodesupportrecord.vue?vue&type=template&id=5a5fdc3a&scoped=true", function () {
      api.rerender('5a5fdc3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/desk/videodecodesupportrecord.vue"
export default component.exports